import React from "react";
import flatten from "lodash/flatten";
import {
  ProductExchangeTypeInstructions,
  ProductExchangeTypeMailing,
  PromoCodeTypePodcasterUnique,
} from "../../../constants/campaigns";
import Moment from "moment";
import moment from "moment";
import { formatMoney } from "../../../lib/format-money";
import { addressToString } from "../../../lib/postal_address";
import papa from "papaparse";
import { downloadFile } from "../../lib/download_file";
import isEmpty from "lodash/isEmpty";
import sortBy from "lodash/sortBy";

export const downloadPodcastInfo = (
  campaign,
  /* any[] contains budget and show as well on the item (e.g. item.budget, item.show)  */
  campaignItems,
  updateCampaignMeta
) => {
  if (isEmpty(campaign) || isEmpty(campaignItems)) {
    return;
  }

  campaignItems = sortBy(campaignItems, "respondedAt");
  const shows = flatten(
    campaignItems.map(({ show, totalBudget, respondedAt, redemptionCodes, promoCode }) => {
      const hosts = show.advertisementSettings.hosts;

      let rows = hosts.map(({ fullName, postalAddress }, i) => {
        if (i > 0) {
          // We don't want duplicate rows when we aren't explicitly showing per host information.
          // Ex. No host name => every row is the same since host name was the only difference
          if (campaign.productExchangeType !== ProductExchangeTypeMailing) {
            return null;
          }

          // No need to include per host info if their is no mailing address to send product to
          if (
            campaign.productExchangeType === ProductExchangeTypeMailing &&
            isEmpty(postalAddress)
          ) {
            return null;
          }
        }

        return {
          "Accepted Date": Moment.unix(respondedAt).format("lll"),
          "Show Name": show.title,
          ...(i === 0 && { Amount: formatMoney(totalBudget) }),
          ...(i === 0 &&
            campaign.promoCodeType === PromoCodeTypePodcasterUnique && {
              "Promo Code": promoCode || show.promoCode,
            }),
          ...(campaign.productExchangeType === ProductExchangeTypeMailing && {
            "Host Name": `${fullName.firstName} ${fullName.lastName}`,
            "Mailing Address": addressToString(postalAddress, true),
          }),
          ...(i === 0 &&
            campaign.productExchangeType === ProductExchangeTypeInstructions && {
              "Redemption Codes": redemptionCodes,
            }),
        };
      });

      return rows.filter(row => row !== null);
    })
  );

  const csv = papa.unparse(shows);
  const currentMs = Moment.now();
  downloadFile(`${campaign.name}_${currentMs}.csv`, csv);
  updateCampaignMeta(campaign.uuid, { csvLastExportedAt: moment().unix() });
};

const DownloadPodcastInfoLink = props => {
  const {
    campaign,
    /* contains budget and show as well on the item  */
    campaignItems,
    updateCampaignMeta,
  } = props;

  return (
    <div
      className="fake-link m-lxxs"
      key={"export-podcast"}
      onClick={() => downloadPodcastInfo(campaign, campaignItems, updateCampaignMeta)}>
      Download Podcast Info
    </div>
  );
};

export default DownloadPodcastInfoLink;
